import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var Access;
(function (Access) {
    Access["Denied"] = "denied";
    Access["Error"] = "error";
    Access["Granted"] = "granted";
    /** @deprecated No longer needed */
    Access["Mismatch"] = "mismatch";
    Access["Pending"] = "pending";
})(Access || (Access = {}));
export var ComponentName;
(function (ComponentName) {
    ComponentName["Checkout"] = "checkout";
    ComponentName["Configurator"] = "configurator";
    ComponentName["Fincalc"] = "fincalc";
    ComponentName["Insurance"] = "insurance";
    ComponentName["Myaccount"] = "myaccount";
    ComponentName["Se"] = "se";
})(ComponentName || (ComponentName = {}));
export var DealTypes;
(function (DealTypes) {
    DealTypes["Enquiries"] = "enquiries";
    DealTypes["Orders"] = "orders";
    DealTypes["Reservations"] = "reservations";
    DealTypes["SavedCars"] = "savedCars";
})(DealTypes || (DealTypes = {}));
export var DepositType;
(function (DepositType) {
    DepositType["Absolute"] = "absolute";
    DepositType["Percentage"] = "percentage";
})(DepositType || (DepositType = {}));
export var DisabledDeal;
(function (DisabledDeal) {
    DisabledDeal["DealInfoOutOfDate"] = "dealInfoOutOfDate";
    DisabledDeal["FinanceApplicationExists"] = "financeApplicationExists";
    DisabledDeal["ModifiedByDealer"] = "modifiedByDealer";
})(DisabledDeal || (DisabledDeal = {}));
export var FacetOptionStatus;
(function (FacetOptionStatus) {
    FacetOptionStatus["Disabled"] = "DISABLED";
    FacetOptionStatus["Enabled"] = "ENABLED";
    FacetOptionStatus["Selected"] = "SELECTED";
})(FacetOptionStatus || (FacetOptionStatus = {}));
export var FeatureType;
(function (FeatureType) {
    FeatureType["Multi"] = "multi";
    FeatureType["Mutex0"] = "mutex0";
    FeatureType["Mutex1"] = "mutex1";
})(FeatureType || (FeatureType = {}));
export var FinanceFormType;
(function (FinanceFormType) {
    FinanceFormType["Cash"] = "cash";
    FinanceFormType["Finance"] = "finance";
})(FinanceFormType || (FinanceFormType = {}));
export var FinanceResultType;
(function (FinanceResultType) {
    FinanceResultType["Cash"] = "cash";
    FinanceResultType["Error"] = "error";
    FinanceResultType["Finance"] = "finance";
    FinanceResultType["Na"] = "na";
    FinanceResultType["NotApplicable"] = "not_applicable";
})(FinanceResultType || (FinanceResultType = {}));
export var JourneyType;
(function (JourneyType) {
    JourneyType["ContinueInDealership"] = "continue_in_dealership";
    JourneyType["OnlineOrder"] = "online_order";
    JourneyType["PreOrderNow"] = "pre_order_now";
    JourneyType["ReserveOnline"] = "reserve_online";
    JourneyType["SaveMyBuild"] = "save_my_build";
})(JourneyType || (JourneyType = {}));
export var LoanTermPeriodUnit;
(function (LoanTermPeriodUnit) {
    LoanTermPeriodUnit["Month"] = "month";
})(LoanTermPeriodUnit || (LoanTermPeriodUnit = {}));
export var MiscellaneousOptionTypes;
(function (MiscellaneousOptionTypes) {
    MiscellaneousOptionTypes["DefaultInput"] = "defaultInput";
    MiscellaneousOptionTypes["SubaruAuInput"] = "subaruAuInput";
})(MiscellaneousOptionTypes || (MiscellaneousOptionTypes = {}));
export var MyAccountRedirectTarget;
(function (MyAccountRedirectTarget) {
    MyAccountRedirectTarget["Login"] = "login";
    MyAccountRedirectTarget["SetPassword"] = "setPassword";
})(MyAccountRedirectTarget || (MyAccountRedirectTarget = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["OrderCar"] = "order_car";
    PaymentType["ReservationFee"] = "reservation_fee";
})(PaymentType || (PaymentType = {}));
export var PriceTypes;
(function (PriceTypes) {
    PriceTypes["FinalPrice"] = "FinalPrice";
    PriceTypes["NetPrice"] = "NetPrice";
})(PriceTypes || (PriceTypes = {}));
export var Source;
(function (Source) {
    Source["Checkout"] = "checkout";
    Source["FinanceApplication"] = "financeApplication";
    Source["Insurance"] = "insurance";
})(Source || (Source = {}));
export var StockType;
(function (StockType) {
    StockType["Dealer"] = "dealer";
    StockType["Distribution"] = "distribution";
})(StockType || (StockType = {}));
export var TokenType;
(function (TokenType) {
    TokenType["Bearer"] = "BEARER";
})(TokenType || (TokenType = {}));
export const ExpressionOfInterestFragmentDoc = gql `
    fragment ExpressionOfInterest on ExpressionOfInterest {
  code
  enabled
  attributes {
    picture
    label
    description
  }
}
    `;
export const AppointmentDetailsFragmentDoc = gql `
    fragment AppointmentDetails on Appointment {
  preferredDate
  preferredTime
  attributes {
    comments
    salesConsultant
  }
}
    `;
export const CustomerAttributesFragmentDoc = gql `
    fragment CustomerAttributes on CustomerAttributes {
  salutation
  postCode
  street
  city
  state
  country
  areaCode
  areaCodeKey
  preferredContactMethod
}
    `;
export const CustomerFragmentDoc = gql `
    fragment Customer on Customer {
  firstName
  lastName
  phone
  email
  attributes {
    ...CustomerAttributes
  }
}
    ${CustomerAttributesFragmentDoc}`;
export const CustomerDetailsFragmentDoc = gql `
    fragment CustomerDetails on Customer {
  salutation
  firstName
  lastName
  phone
  email
  identificationNumber
  marketingInformation
  companyName
  attributes {
    ...CustomerAttributes
  }
}
    ${CustomerAttributesFragmentDoc}`;
export const MoneyFragmentDoc = gql `
    fragment Money on Money {
  amount
  currency
}
    `;
export const PriceFragmentDoc = gql `
    fragment Price on Price {
  money {
    ...Money
  }
  type
}
    ${MoneyFragmentDoc}`;
export const BadgeFragmentDoc = gql `
    fragment Badge on Badge {
  image
  label
}
    `;
export const DiscountFragmentDoc = gql `
    fragment Discount on Discount {
  code
  badge {
    ...Badge
  }
  label
  value {
    ...Money
  }
  disclaimer
}
    ${BadgeFragmentDoc}
${MoneyFragmentDoc}`;
export const OffersFragmentDoc = gql `
    fragment Offers on Offers {
  badge {
    ...Badge
  }
  discounts {
    ...Discount
  }
}
    ${BadgeFragmentDoc}
${DiscountFragmentDoc}`;
export const DealCarPriceFragmentDoc = gql `
    fragment DealCarPrice on DealCarPrice {
  originalPrice {
    ...Price
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...Price
  }
  offers {
    ...Offers
  }
}
    ${PriceFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const DealFeatureFragmentDoc = gql `
    fragment DealFeature on DealFeature {
  id
  shortname
  code
  categoryCode
  prices {
    ...Price
  }
}
    ${PriceFragmentDoc}`;
export const FinanceValueFragmentDoc = gql `
    fragment FinanceValue on FinanceValue {
  amount
  currency
}
    `;
export const DealFinanceFragmentDoc = gql `
    fragment DealFinance on DealFinance {
  type
  formInput {
    paymentType
    financeProductId
    term
    deposit
    interestRate
    mileage
  }
  simulation {
    amountPayable {
      ...Money
    }
    totalAmountPayable {
      ...Money
    }
    comparisonRate
    interestRate
    loanTermPeriod {
      unit
      value
    }
    paymentValue {
      ...Money
    }
    frequency
    deposit {
      ...Money
    }
    attributes {
      upfrontFees {
        ...FinanceValue
      }
      residualAmount {
        ...FinanceValue
      }
      depositAmountPercentage
      calculatorNetPrice
      balloonAmountPercentage
      residualAmountPercentage
    }
    financePackageId
    financeProductId
    financeProductName
    oneForOne
  }
  breakdown {
    schema
  }
}
    ${MoneyFragmentDoc}
${FinanceValueFragmentDoc}`;
export const DealerFragmentDoc = gql `
    fragment Dealer on Dealer {
  label
  address {
    name
    address
    city
    phone
  }
  postCode
}
    `;
export const DisclaimerFragmentDoc = gql `
    fragment Disclaimer on Disclaimer {
  value
  needsToBeTranslated
}
    `;
export const EngineFragmentDoc = gql `
    fragment Engine on Engine {
  code
  attributes {
    shortdescription
    longdescription
    fuelType
    fuelLabel
    powertrain
    capacity
    transmissionLabel
  }
}
    `;
export const ExteriorFragmentDoc = gql `
    fragment Exterior on Exterior {
  shortname
  attributes {
    oemcode
  }
  price {
    money {
      ...Money
    }
  }
}
    ${MoneyFragmentDoc}`;
export const InteriorFragmentDoc = gql `
    fragment Interior on Interior {
  shortname
  attributes {
    oemcode
  }
  price {
    money {
      ...Money
    }
  }
}
    ${MoneyFragmentDoc}`;
export const ModelFragmentDoc = gql `
    fragment Model on Model {
  code
  attributes {
    oemcode
    shortname
    modelyear
    brand
    fullSpecsUrl
    longdescription
  }
}
    `;
export const PaymentFeeFragmentDoc = gql `
    fragment PaymentFee on PaymentFee {
  reserveFee {
    ...Money
  }
  orderFee {
    ...Money
  }
}
    ${MoneyFragmentDoc}`;
export const BaseImageFragmentDoc = gql `
    fragment BaseImage on Image {
  url
  type
}
    `;
export const CarPriceFragmentDoc = gql `
    fragment CarPrice on CarPrice {
  originalPrice {
    ...Price
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...Price
  }
  offers {
    ...Offers
  }
}
    ${PriceFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const FinanceFragmentDoc = gql `
    fragment Finance on FinanceResult {
  type
  simulation {
    paymentValue {
      currency
      amount
    }
    interestRate
    comparisonRate
    frequency
    loanTermPeriod {
      value
      unit
    }
    deposits {
      value
      type
    }
  }
}
    `;
export const SimilarStockCarsFragmentDoc = gql `
    fragment SimilarStockCars on PimStockCar {
  carId
  vin
  selectedFeatures {
    selected
    added
    removed
    merged {
      merged
      into
    }
    requiresOneOf
  }
  images {
    ...BaseImage
  }
  carPrice {
    ...CarPrice
  }
  finance(financeFormInput: $financeFormInput) {
    ...Finance
  }
  carMatchLabel
  keyFeatures {
    id
    shortname
    shortDescription
    longDescription
    code
    categoryCode
  }
}
    ${BaseImageFragmentDoc}
${CarPriceFragmentDoc}
${FinanceFragmentDoc}`;
export const SpecPackFragmentDoc = gql `
    fragment SpecPack on SpecPack {
  code
  attributes {
    shortname
  }
}
    `;
export const VariantFragmentDoc = gql `
    fragment Variant on Variant {
  code
  attributes {
    name
    year
    modelName
    fullSpecsUrl
  }
}
    `;
export const GetTranslationsDocument = gql `
    query GetTranslations {
  translations {
    code
    value
  }
}
    `;
/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTranslationsDocument, options);
}
export function useGetTranslationsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTranslationsDocument, options);
}
//# sourceMappingURL=graphql.autogenerated.js.map